import Cookies from "js-cookie"

export const NEXT_VISITOR_COOKIE = "NextVisitor"
export const NEXT_VISITOR_SESSION_STORAGE_KEY = "NextVisitorTimestamp"
const nextVisitorValueRegex = /(?:LatestSessionTimestamp)=(?<value>.*?)(&|$)/
const timestampRegex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})/ // DD/MM/YYYY HH:mm:ss

export const getNextVisitorCookieTimestamp = (): Date | null => {
    const cookieValue = Cookies.get(NEXT_VISITOR_COOKIE)
    if (!cookieValue) return null

    const latestSessionMatch = cookieValue.match(nextVisitorValueRegex)
    const ddMMyyyyHHssDate = latestSessionMatch?.groups?.value
    if (!ddMMyyyyHHssDate) return null

    const dateMatch = ddMMyyyyHHssDate.match(timestampRegex)

    if (!dateMatch) return null

    const [_, day, month, year, hour, minute, second] = dateMatch
    const mmDDyyHHmmssDate = `${month}/${day}/${year} ${hour}:${minute}:${second}`

    const date = Date.parse(mmDDyyHHmmssDate)
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(date)) return null
    return new Date(date)
}

export const setSessionStorageTimestamp = (value: Date) => {
    if (typeof window === "undefined") return null

    if (value) {
        const epochTime = value.getTime()

        window.sessionStorage.setItem(NEXT_VISITOR_SESSION_STORAGE_KEY, epochTime.toString())
    }
}

export const getSessionStorageTimestamp = (): Date => {
    if (typeof window === "undefined") return new Date()

    const value = window.sessionStorage.getItem(NEXT_VISITOR_SESSION_STORAGE_KEY)
    if (value) {
        const epochTime = parseInt(value, 10)
        if (!Number.isNaN(epochTime)) {
            return new Date(epochTime)
        }
    }

    return new Date()
}

export const removeSessionStorageTimestamp = () => {
    if (typeof window === "undefined") return

    window.sessionStorage.removeItem(NEXT_VISITOR_SESSION_STORAGE_KEY)
}
